/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface Apiv3backofficeinventoryguestroomratesuploadDataAttributes
 */
export interface Apiv3backofficeinventoryguestroomratesuploadDataAttributes {
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficeinventoryguestroomratesuploadDataAttributes
     */
    occupancyType: Apiv3backofficeinventoryguestroomratesuploadDataAttributesOccupancyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficeinventoryguestroomratesuploadDataAttributes
     */
    price: string;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficeinventoryguestroomratesuploadDataAttributes
     */
    rateEndDate: string;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficeinventoryguestroomratesuploadDataAttributes
     */
    rateStartDate: string;
    /**
     * 
     * @type {string}
     * @memberof Apiv3backofficeinventoryguestroomratesuploadDataAttributes
     */
    rentalType: Apiv3backofficeinventoryguestroomratesuploadDataAttributesRentalTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum Apiv3backofficeinventoryguestroomratesuploadDataAttributesOccupancyTypeEnum {
    Single10 = 'single-1-0',
    Double20 = 'double-2-0',
    Double11 = 'double-1-1',
    Triple30 = 'triple-3-0',
    Triple21 = 'triple-2-1',
    Triple12 = 'triple-1-2',
    Quadruple40 = 'quadruple-4-0',
    Quadruple31 = 'quadruple-3-1',
    Quadruple22 = 'quadruple-2-2',
    Quadruple13 = 'quadruple-1-3',
    Quintuple50 = 'quintuple-5-0',
    Quintuple41 = 'quintuple-4-1',
    Quintuple32 = 'quintuple-3-2',
    Quintuple23 = 'quintuple-2-3',
    Quintuple14 = 'quintuple-1-4'
}
/**
    * @export
    * @enum {string}
    */
export enum Apiv3backofficeinventoryguestroomratesuploadDataAttributesRentalTypeEnum {
    Accommodation = 'accommodation',
    Breakfast = 'breakfast',
    FullBoard = 'full-board',
    HalfBoard = 'half-board',
    AllInclusive = 'all-inclusive'
}

